function generateInstagramTemplate(url, likes, caption, date) {
  return `<div class="Instafeed__Cell">` + `<div class="Instafeed__Image Image--lazyLoad Image--zoomOut" data-expand="10" data-bg="${url}" aria-label="Open on Instagram"></div>`  + '</div>';
}




async function fetchIGFeed() {

  $.ajax({
    url: `https://insta-feed-bucket.s3.eu-central-1.amazonaws.com/awake.json`, // or /users/self/media/recent for Sandbox
    type: 'GET',
    beforeSend: function(request) {
      request.setRequestHeader("Access-Control-Allow-Origin", "*");
    },
    success: function(response) {
      const media = response.data;

      $('#media').append(media.length + '<p class=\'ig\'> posts </p>');

      const images = media.map(node => {
        const url = node['media_url'];
        const time = node['timestamp'];
        const caption = node['caption']
        return generateInstagramTemplate(url, null, caption, '');
      });

      if (isMobile()) {

        var append_image = images.slice(0, 1);
        var append_image2 = images.slice(1, 6);
        var append_image3 = images.slice(6, 10);


        $('.Instafeed_Row_1 .instafeed__column_1').append(append_image);
        $('.Instafeed_Row_1 .instafeed__column_2').append(append_image2);


        $('.Instafeed_Row_2 .instafeed__column_2').append(append_image3);
      } else{
        var append_image = images.slice(0, 1);
        var append_image2 = images.slice(1, 7);


        $('.Instafeed_Row_1 .instafeed__column_1').append(append_image);
        $('.Instafeed_Row_1 .instafeed__column_2').append(append_image2);

      }
    }
  });
}

function toggleSpec() {
$('.specifications_tab_selector').on('click',function(){
var open =  $(this).attr('aria-id');
$(this).addClass('is-active').siblings().removeClass('is-active');
  $('#'+open).addClass('is-active').siblings().removeClass('is-active');
});
}


/*MOBILE SIDEBAR MENU DRAWERS*/
function openMenuMobile(){
  $('.collapsible_next').on('click', function(){

	var newEl = $(this).closest('.Collapsible');
    let id =  newEl.attr('data-id');

    if(id){
       $("#"+id).addClass('opened_mobile_collapsible');
    $("#main_drawer_content").addClass("move_mobile_collapsible");

    }

  });

  $('.previ').on('click', function(){
    let id =  $(this).attr('data-id');
    $("#"+id).removeClass('opened_mobile_collapsible');
    $("#main_drawer_content").removeClass("move_mobile_collapsible");
  });

}

/*SEARCH FUNCTION SIMPLE*/
function search() {
  let input = document.getElementById('searchbar').value
  input = input.toLowerCase();
  let x = document.getElementsByClassName('retaliers_country');

  for (i = 0; i < x.length; i++) {
    if (!x[i].innerHTML.toLowerCase().includes(input)) {
      x[i].style.display = "none";
    } else {
      x[i].style.display = "block";
    }
  }
}

function searchNewsletter() {
  let input = document.getElementById('searchbarNewsletter').value
  input = input.toLowerCase();
  let x = document.getElementsByClassName('newsletterCountry');
  for (i = 0; i < x.length; i++) {
    if (!x[i].innerHTML.toLowerCase().includes(input)) {
      x[i].style.display = "none";
    } else {
      x[i].style.display = "block";
    }
  }
}

//Main menu image toggle
function popupWindow() {
  $('a.-splitit--learn-more')[0].click();
}

function toggleMenuImage() {



  $(".MegaMenu__Title").hover(
    function() {


      var id = $(this).attr('id');
      var myID = '#' + id + "_this";
      $(myID).toggleClass('openItem');
    },
    function() {
      var id = $(this).attr('id');
      var myID = '#' + id + '_this';
      $(myID).toggleClass('openItem');
    }
  );

  $(".MainMenu--SubItem--Item").hover(
    function() {
      var id = $(this).attr('id');
      var myID = '#' + id + "_this";
      $(myID).toggleClass('openItem');
    },
    function() {
      var id = $(this).attr('id');
      var myID = '#' + id + '_this';
      $(myID).toggleClass('openItem');
    }
  );

}

function isMobile() {
  const width = $(window).width();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
  return isMobile;
}



function toggleretailers() {
  $(".retaliers_country").on("click", function() {



    $(this).toggleClass('country_open');
    $('.retaliers_country').not(this).each(function() {
      $(this).removeClass('country_open');

    });
    var call = $(this).attr("data-c");

    $("#" + call).toggleClass('red').siblings().removeClass('red');
  });

  $("path.dots").on("click", function() {

    $('#searchbar').val("");
    search();

    var call = $(this).attr('id');

    var height = $(".countries").height();
    $(".countries").scrollTo($("#ph_" + call + " button"), 300);


    setTimeout(function() {
      $("#ph_" + call + " button").click();
    }, 600);
  });



  $(".Collapsible__Button ").on("click", function() {
    var $this = $(this);

    setTimeout($(".countries").scrollTo($this), 600);

  });

}



function stackedNews() {

  var i = 0;
  var height = $(".stacked__article").height();
  var width = $(".stacked__article").width();
  var vTranslate = 0;
  var numItems = $('.stacked__article').length;
  var hTranslate = 0;


  var maxHeight = -1;

  var heights = $(".stacked").map(function() {
    return $(this).height();

  }).get();

  maxHeight = Math.max.apply(null, heights);
  var items = (numItems) * (60);
  var finalH = maxHeight + items + 70;

  $('.article_section--wrapper').css("min-height", finalH);

  $(".stacked__article").each(function(index) {

    hTranslate = (numItems - i) * width;
    vTranslate = (numItems - i) * (60);


    $(this).css({
      transform: 'translate(0px, ' + vTranslate + 'px)'
    });
    $(this).attr('data-translateX', vTranslate);
    $(this).attr('data-translateh', hTranslate);
    $(this).css({
      transform: 'translate(' + hTranslate + 'px, ' + vTranslate + 'px)'
    });
    i++;
  });




  
  let callback = (entries, observer) => {

    entries.forEach((entry) => {
      if (entry.isIntersecting == true){
        if ($('.article_section--wrapper').length && !$('.article_section--wrapper').hasClass('alreadyOpened')) {
        $('.article_section--wrapper').addClass('alreadyOpened');


        var hTranslate = 0;



        $($(".stacked__article").get().reverse()).each(function(index) {

          var that = this;
          var t = setTimeout(function() {
            var vTranslate = $(that).attr('data-translateX');
            $(that).css({
              transform: 'translate(' + hTranslate + 'px, ' + vTranslate + 'px)'
            });
          }, 400 * index);


        });

      }  }
    });
  };

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2
  }
  
  let observer = new IntersectionObserver(callback, options);

  observer.observe(document.querySelector('.article_section--wrapper'));


  $(".stacked__article").on({
    mouseenter: function() {

      var vTranslate_inherit = $(this).attr('data-translateX');

      var newTranslate = vTranslate_inherit - (vTranslate_inherit * 0.1);

      $(this).css({
        transform: 'translate(0px, ' + newTranslate + 'px)'
      });
    },
    mouseleave: function() {

      var vTranslate_inherit = $(this).attr('data-translateX');
      $(this).css({
        transform: 'translate(0px, ' + vTranslate_inherit + 'px)'
      });
    }
  });


}

function stackedNewsMobile() {

  var i = 0;
  var height = $(".stacked__article").outerHeight();
  var nTranslate = 0;
  var numItems = $('.stacked__article').length;
  var headerHeight = $('#stacked_wrapper_1 .info_column').height();
  var y = $(".custom_bg--2 .info_column").outerHeight();
  var z = $(".custom_bg--1 .info_column").outerHeight();
  var m = $(".custom_bg--3 .info_column").outerHeight();

  const calculatedHeight =  z+ m + height ;

  $('#stacked_wrapper_1').css("height", calculatedHeight);

  $(".stacked__article").each(function(index) {

    if (i == 2) {
      var x = $(".custom_bg--2").outerHeight();
      var s = $(".custom_bg--2 .info_column").outerHeight();
      nTranslate = 40 + s - x;
    } else {
      nTranslate = 0;
    }
    $(this).css({
      transform: 'translate(0px, ' + nTranslate + 'px)'
    });
    $(this).attr('data-translateY', nTranslate);
    $(this).attr('data-c-translateY', nTranslate);
    i++;
  });



  $(".stacked__article").on("click", function() {

    $(".info_column", this).attr('aria-expanded', 'true');

    if (!$(this).hasClass("stackOpen")) {
      var hovBox = $(this);
      var nextAll = hovBox.nextAll();
      var prevAll = hovBox.prevAll();

      prevAll.each(function(index) {
        $(".info_column", this).attr('aria-expanded', 'false');
        if (!$(this).hasClass("stackOpen")) {

          var nTranslate_inherit = $(this).attr('data-translateY');

          var nTranslate_inherit = nTranslate_inherit - height + 70;
          $(this).toggleClass('stackOpen');

          $(this).css({
            transform: 'translate(0px, ' + nTranslate_inherit + 'px)'
          });

          $(this).attr('data-c-translateY', nTranslate_inherit);
        }

      });

      var nTranslate_inherit = $(this).attr('data-translateY');


      if (!$(this).hasClass("stackOpen")) {
        var nTranslate_inherit = nTranslate_inherit - height + 100;
      }
      $(this).css({
        transform: 'translate(0px, ' + nTranslate_inherit + 'px)'
      });

      $(this).toggleClass('stackOpen');

      $(this).attr('data-c-translateY', nTranslate_inherit);
    } else {

      var hovBox = $(this);
      var nextAll = hovBox.nextAll();
      var prevAll = hovBox.prevAll();

      nextAll.each(function(index) {
        $(".info_column", this).attr('aria-expanded', 'false');
        var nTranslate_inherit = $(this).attr('data-translateY');


        $(this).css({
          transform: 'translate(0px, ' + nTranslate_inherit + 'px)'
        });
        $(this).removeClass('stackOpen');
        $(this).attr('data-c-translateY', nTranslate_inherit);
      });

    }
  });

}


function stackedItemsMobile() {

$('.stacked_section_desktop').remove();
  var i = 0;
  var oheight = $(".stacked__section").outerHeight(true);
  var height = $(".stacked__section").height();
  var nTranslate = 0;
  var numItems = $('.stacked__section').length;
  var headerHeight = $('.stacked--header').height();
  const calculatedHeight = (numItems - 1) * 71 + oheight + headerHeight + 71;


  $('#stacked_wrapper').css("height", calculatedHeight);

  $(".stacked__section").each(function(index) {

    if (i > 0) {

      nTranslate = (i) * (70) + height;
    } else {
      nTranslate = 21;
    }
    $(this).css({
      transform: 'translate(0px, ' + nTranslate + 'px)'
    });
    $(this).attr('data-translateY', nTranslate);
    $(this).attr('data-c-translateY', nTranslate);
    i++;
  });

  $(".stacked__section").on("click", function() {

    $(".info_column", this).attr('aria-expanded', 'true');

    if (!$(this).hasClass("stackOpen")) {


      var hovBox = $(this);
      var nextAll = hovBox.nextAll();
      var prevAll = hovBox.prevAll();



      prevAll.each(function(index) {
        $(".info_column", this).attr('aria-expanded', 'false');
        if (!$(this).hasClass("stackOpen")) {

          var nTranslate_inherit = $(this).attr('data-translateY');

          var nTranslate_inherit = nTranslate_inherit - height + 80 - 60;
          $(this).toggleClass('stackOpen');

          $(this).css({
            transform: 'translate(0px, ' + nTranslate_inherit + 'px)'
          });

          $(this).attr('data-c-translateY', nTranslate_inherit);
        }

      });

      var nTranslate_inherit = $(this).attr('data-translateY');


      if (!$(this).hasClass("stackOpen")) {
        var nTranslate_inherit = nTranslate_inherit - height + 80 - 60;
      }
      $(this).css({
        transform: 'translate(0px, ' + nTranslate_inherit + 'px)'
      });





      $(this).toggleClass('stackOpen');

      $(this).attr('data-c-translateY', nTranslate_inherit);
    } else {

      var hovBox = $(this);
      var nextAll = hovBox.nextAll();
      var prevAll = hovBox.prevAll();

      nextAll.each(function(index) {
        $(".info_column", this).attr('aria-expanded', 'false');
        var nTranslate_inherit = $(this).attr('data-translateY');


        $(this).css({
          transform: 'translate(0px, ' + nTranslate_inherit + 'px)'
        });
        $(this).removeClass('stackOpen');
        $(this).attr('data-c-translateY', nTranslate_inherit);
      });



    }
  });


}






function stackedItems() {

// $('.stacked_mobile_2_0').remove();
  var i = 0;
  var width = $(".stacked__section").width();

  var nTranslate = 0;
  var numItems = $('.stacked__section').length;
  var hTranslate = 0;
  var vTranslate = 0;
  var maxHeight = -1;
  var zTranslate = 0;
  var heights = $(".stacked").map(function() {
    return $(this).height();

  }).get();

  maxHeight = Math.max.apply(null, heights);
  var items = (numItems) * (60);
  var finalH = maxHeight + items + 40;

  $('#stacked_wrapper').css("min-height", finalH);




  $(".stacked__section").each(function(index) {

    if (index == 0) {
      var middle = $(this).height();
      vTranslate = $(".stacked", this).height();
      vTranslate = middle - vTranslate - 50;
    }


    if (i > 0) {
      nTranslate = (numItems - i) * (-80) + width;
    } else {
      nTranslate = (numItems - 1) * (-80);
    }
    zTranslate = vTranslate - (i * 60);
    $(this).css({
      transform: 'translate(' + nTranslate + 'px, ' + zTranslate + 'px)'
    });
    $(this).attr('data-translateX', zTranslate);
    $(this).attr('data-translateY', nTranslate);
    $(this).attr('data-c-translateY', nTranslate);
    i++;
  });

  $(".stacked__section").on("click", function() {
    if (!$(this).hasClass("stackOpen")) {

      var hovBox = $(this);
      var nextAll = hovBox.nextAll();
      var prevAll = hovBox.prevAll();



      prevAll.each(function(index) {
        if (!$(this).hasClass("stackOpen")) {
          var nTranslate_inherit = $(this).attr('data-translateY');
          var vTranslate_inherit = $(this).attr('data-translateX');



          var nTranslate_inherit = nTranslate_inherit - width + 80;
          $(this).toggleClass('stackOpen');

          $(this).css({
            transform: 'translate(' + nTranslate_inherit + 'px, ' + vTranslate_inherit + 'px)'
          });

          $(this).attr('data-c-translateY', nTranslate_inherit);
        }

      });

      var nTranslate_inherit = $(this).attr('data-translateY');
      var vTranslate_inherit = $(this).attr('data-translateX');

      if (!$(this).hasClass("stackOpen")) {
        var nTranslate_inherit = nTranslate_inherit - width + 80;
      }
      $(this).css({
        transform: 'translate(' + nTranslate_inherit + 'px, ' + vTranslate_inherit + 'px)'
      });





      $(this).toggleClass('stackOpen');

      $(this).attr('data-c-translateY', nTranslate_inherit);
    } else {

      var hovBox = $(this);
      var nextAll = hovBox.nextAll();
      var prevAll = hovBox.prevAll();

      nextAll.each(function(index) {

        var nTranslate_inherit = $(this).attr('data-translateY');
        var vTranslate_inherit = $(this).attr('data-translateX');

        $(this).css({
          transform: 'translate(' + nTranslate_inherit + 'px, ' + vTranslate_inherit + 'px)'
        });
        $(this).removeClass('stackOpen');
        $(this).attr('data-c-translateY', nTranslate_inherit);
      });



    }
  });


  $(".stacked__section").on({
    mouseenter: function() {
      var nTranslate_inherit = $(this).attr('data-c-translateY');
      var vTranslate_inherit = $(this).attr('data-translateX');
      if (!$(this).hasClass("stackOpen")) {
        var newTranslate = nTranslate_inherit - (nTranslate_inherit * 0.015);

        $(this).css({
          transform: 'translate(' + newTranslate + 'px, ' + vTranslate_inherit + 'px)'
        });
      }
    },
    mouseleave: function() {
      var nTranslate_inherit = $(this).attr('data-c-translateY');
      var vTranslate_inherit = $(this).attr('data-translateX');
      $(this).css({
        transform: 'translate(' + nTranslate_inherit + 'px, ' + vTranslate_inherit + 'px)'
      });
    }



  });


  $(".stacked__section").each(function(index) {
    var width = $(".stacked__section").width();
    hTranslate = width + (numItems - 1) * 80;
    vTranslate = $(this).attr('data-translatex');


    $(this).css({
      transform: 'translate(' + hTranslate + '+px,' + vTranslate + 'px)'
    });
    $(this).css({
      transform: 'translate(' + hTranslate + 'px, ' + vTranslate + 'px)'
    });



    i++;
  });


  $(window).scroll(function() {

    if ($('#stacked_wrapper').length && !$('#stacked_wrapper').hasClass('alreadyOpened')) {

      var hT = $('#stacked_wrapper').offset().top - 400,
        hH = $('#stacked_wrapper').outerHeight(),
        wH = $(window).height(),
        wS = $(this).scrollTop();

      if (wS > (hT + hH - wH) && ((hT * 2) > wS) && (wS + wH > hT + hH)) {

        $('#stacked_wrapper').addClass('alreadyOpened');

        $($(".stacked__section").get().reverse()).each(function(index) {

          var that = this;
          var t = setTimeout(function() {
            var vTranslate = $(that).attr('data-translatex');
            var hTranslate = $(that).attr('data-translatey');
            $(that).css({
              transform: 'translate(' + hTranslate + 'px, ' + vTranslate + 'px)'
            });
          }, 300 * index);


        });


      }
    }
  });





}

function toggleSupport() {
  $(".Questions").on("click", function() {

    $(this).toggleClass('open_question').siblings().removeClass('open_question');


  });

  $(".columns").on("click", function() {

    $(this).toggleClass('open_q_style').siblings().removeClass('open_q_style');
    var call = $(this).attr('id');


    $("#ph_" + call).toggleClass('open_q').siblings().removeClass('open_q');

  });
}



let firstRecommended = true;

$(document).ready(function() {
  if (firstRecommended == true){
    renderCartRecommendations();
    firstRecommended = false;
  }

  var observervideo = new IntersectionObserver(onIntersection, {
    root: null,   // default is the viewport
    threshold: 0.1 // percentage of taregt's visible area. Triggers "onIntersection"
  });

  function onIntersection(entries, opts){
    entries.forEach((item, i) => {

      if(item.isIntersecting == true){
      videoPlayerInicialization(item.target);
    }
    });


  }
  var el = document.querySelectorAll('.wrapper_click--video');
  el.forEach((item, i) => {
    observervideo.observe(item);
  });


openMenuMobile();
toggleSpec();

if (isMobile()) {

  //    fetchIGFeed();
$(".Scrolling__Banner").marquee({ speed: 20, gap: 32, delayBeforeStart: 0, direction: "left", duplicated: !0, startVisible: !0 });

}


  if (isMobile()) {
    $('.tooltip--close').on('click touchstart', function(event) {

      $('.tooltiptext').removeClass("visable--modal");

    });
  } else {
    $('.tooltip--close').on('click', function() {

      $('.tooltiptext').removeClass("visable--modal");

    });
  }
  $('.tooltip-click').on('click', function(event) {
    if($(this).attr('data-tooltips') == "first" ){
   $('.tooltiptext--first').toggleClass("visable--modal");
    $('.tooltiptext--second').removeClass("visable--modal");
    }else{
      $('.tooltiptext--second').toggleClass("visable--modal");
       $('.tooltiptext--first').removeClass("visable--modal");
    }




  });
  modalCheckout();
  upgradeAll();
  spec_top();
  adjust_spec();
  popupadjust();
  toggleSupport();
  toggleretailers();
  moveTeaser();
  if (isMobile()) {
    stackedItemsMobile();
    stackedNewsMobile();
  } else {
    toggleMenuImage();
    stackedNews();
    stackedItems();
  }

  upgradeModule();
});

function moveTeaser(){
  $('.close--teaser').on('click', function(){



         $('.PageOverlay').removeClass('site-blacked');
        $('.teaser').attr('aria-hidden', 'true');
          setTimeout(function(){

                               $('.teaser').addClass('teaser-not');
            		  $('body').removeClass('no-scroll');
                               }, 700);
    localStorage.setItem("teaser",'true');
  });



}

function videoPlayerInicialization(element) {

      let el = $(element);

      var options = JSON.parse($('.video-js', element).attr('data-section-settings'));
      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
      let img_plh = "";
      let aspect_ratio = "";
      let src = "";
      let host = "html5";

      if (isMobile) {
        if(options["mobDisable"]){
          el.closest('.shopify-section').remove();
          return;
        }
        if (options["control_var"]) {
            src = options["videom"];
        } else if (options["video_inside_media"]) {
            src = options["videom"]["sources"][1]["url"];
        } else {
         
            src = "https://www.youtube.com/watch?v=" + options["videod"];
            host = options["host"];
        }
        img_plh = options["plh_mob"];
        if (options["aspect_mob"]) {
            aspect_ratio = options["aspect_mob"];
        } else {
            aspect_ratio = "9:16";
        }

      } else {
        if(options["deskDisable"]){
          el.closest('.shopify-section').remove();
          return;
        }
        if (options["control_var"]) {
            src = options["videod"];
        } else if (options["video_inside_media"]) {
            src = options["videod"]["sources"][1]["url"];
        } else {
       
          src = "https://www.youtube.com/watch?v="  +  options["videod"];
            host = options["host"];
        }
        img_plh = options["plh_desk"];
        if (options["aspect_desk"]) {
            aspect_ratio = options["aspect_desk"];
        } else {
            aspect_ratio = "16:9";
        }

      }

      if (host == "youtube") {
          var type = "video/youtube";
      } else {
          var type = "video/mp4";
      }

      if(!options['plh']){
        img_plh = false;
      }

        var payload = {
          aspectRatio: aspect_ratio,
          autoplay: options['autoplay'],
          muted: options['muted'],
          loop: options['loop'],
          controls: options['controls'],
          poster: img_plh,
          preload: "none",
          playsinline: true,
          responsive: true,
          techOrder: [host],
          disablePictureInPicture: true,
          controlBar: {
            playToggle: true,
            captionsButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            remainingTimeDisplay: false,
            pictureInPictureToggle: false,
            volumeControl: false,
            progressControl: {
              seekBar: true
            },
            fullscreenToggle: false,
            playbackRateMenuButton: false,
          },
          sources: [{
            type: type,
            src: src
          }]

        };
      


      var observer = new IntersectionObserver(waitforviewport, {
        root: null, // default is the viewport
        threshold: 0.2, // percentage of taregt's visible area. Triggers "onIntersection"
      });

   
      let videoplayerID = "my-player-" + options["id"];
      var myPlayer = videojs(videoplayerID, payload);

   
      myPlayer.on("ready", function () {

        if (options["viewport"]) {
          observer.observe(element);
        }  

        if (options["host"] != "youtube") {
          toggleVideo();
    
          el.closest(".ImageHero--teaser").show();
        } else {
          $(window).scrollTop($(window).scrollTop() + 1);
   
        }
        el.show();

        if(options['autoplay']){
          setTimeout(() => {
            myPlayer.play();

          }, "2000")
        }
   
      });





}


  $('[data-action="open-video"]').on('click', function() {
      const videoElement = event.target.getAttribute('aria-controls');
      const id = videoElement.replace('videoModal--','');
      const el = document.querySelector(`#${videoElement} .wrapper_click--video`);
      videoPlayerInicialization(el);
      $(`#toggleYoutube--${id}`).click();

  });

function updateCartTotalNumber(data) {
  const addToCart = parseInt(data.detail.quantity);
  const currentTotal = parseInt($('.Header__CartCount:eq(0)').text());
  const newTotal = currentTotal + addToCart;

  $('.Header__CartCount').html(newTotal);

}


document.addEventListener('search:loaded', function(data) {

  hideSearchBarButtons();
});

document.addEventListener('product:added', function(data) {
  upgradeModule();

});

document.addEventListener('addons-number:update_c', function(data) {
  setTimeout(function() {
    upgradeModule();
  }, 200);

});


function handleATCSubmit(event) {
  event.preventDefault();

  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  var addToCartButton = $('.ProductForm__AddToCart');
  addToCartButton.attr('disabled');

  const serializedArray = $(this).serializeArray()
  const data = serializedArray.reduce((acc, val) => {

    acc[val.name] = val.value;

    return acc;
  }, {})

  fetch(window.theme.localeRootUrl + '/cart/add.js', {
    body: JSON.stringify(data),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function(response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      addToCartButton.removeAttr('disabled');

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: data.id,
          quantity: data.quantity
        }
      }));
    } else {
      response.json().then(function(content) {
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];
        addToCartButton.removeAttribute('disabled');
        addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
        setTimeout(function() {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
}


function popupadjust() {

  if ($('.tooltiptext').length > 0) {

    let height = $('.tooltiptext').outerHeight() * -1 - 24;
    $('.tooltiptext').css("top", height);
    $('.tooltiptext').css("right", 8);
  }


}

//Check if Safari
  function isSafari() {
      return /^((?!chrome).)*safari/i.test(navigator.userAgent);
  }
//Check if MAC
     if(navigator.userAgent.indexOf('Mac')>1){
    $("body").addClass("safari-browser");
     }

function toggleVideo() {
  $('.wrapper_click--video').on('click', function() {
    var sph = $(this).attr('data-plh');
    var id = $(this).attr('data-id');
    var videoplayerID = 'my-player-' + id;
    var myPlayer = videojs.getPlayer(videoplayerID);

    if (myPlayer.paused()) {
      myPlayer.play();
      if (sph == "true") {
        $('.vjs-poster', this).css("display", "none");
      }
    } else {
      myPlayer.pause();
      if (sph == "true") {
        $('.vjs-poster', this).css("display", "inline-block");
      }
      $(this).attr('data-pause', true)
    }

  });



}




function waitforviewport(entries) {

    const element = entries[0].target;
    const id = $(element).attr("data-id");
    var customID = "my-player-" + id;
    var myPlayer = videojs.getPlayer(customID);

    var manual = $(element).attr("data-pause");

      if (entries[0].isIntersecting != true) {
        myPlayer.pause();
     
        $("." + customID + " .vjs-poster").css("display", "inline-block");
      } else {
        if (!manual) {
          myPlayer.play();
 
          $("." + customID + " .vjs-poster").css("display", "none");
        }
      }
 
}

// Helper to check if a product is an Early Bird pre-order
function isEarlyBirdProduct(productId) {
  const campaign = window.EBGlobal?.settings?.campaign;
  return campaign?.productIds?.some(gid =>
    gid.split('/').pop() === productId
  );
}

// Helper to show/update loading bar
function updateLoadingBar(progress) {
  const loadingBar = $('.LoadingBar');
  if (progress === 0) {
    loadingBar.addClass('is-visible');
  }
  loadingBar.css('width', `${progress}%`);
  if (progress === 100) {
    loadingBar.addClass('is-finished');
  }
}

// Main add to cart function
async function addToCart(formData) {
  try {
    updateLoadingBar(40);

    // Construct the cart item with all necessary properties
    const cartItem = {
      items: [{
        id: formData.id,
        quantity: formData.quantity || 1,
        properties: {}  // Only add properties if they exist
      }]
    };

    // Only add properties if they exist
    if (formData['properties[_EarlyBird]']) {
      cartItem.items[0].properties = {
        '_EarlyBird': formData['properties[_EarlyBird]'],
        '_EarlyBirdCampaign': formData['properties[_EarlyBirdCampaign]'],
        'Purchase option': formData['properties[Purchase option]'],
        'Expected ship date': formData['properties[Expected ship date]']
      };
    }

    // Only add selling_plan if it exists
    if (formData.selling_plan) {
      cartItem.items[0].selling_plan = formData.selling_plan;
    }

    console.log('Sending cart data:', cartItem);

    const response = await fetch(window.theme.localeRootUrl + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(cartItem)
    });

    const data = await response.json();
    console.log('Cart response with keys:', data);
    if (!response.ok) {
      throw new Error(data.description || 'Add to cart failed');
    }

    updateLoadingBar(100);

    // Trigger the product:added event which will handle cart updates
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: data.items[0],
        quantity: data.items[0].quantity
      }
    }));

  } catch (error) {
    console.error('Cart error:', error);
    alert('Oops! Something went wrong. Please try to add your product again.');
    throw error;
  }
}

// Main entry point
async function addtocartmodal(id, quantity) {
  event.preventDefault();

  const form = event.target.closest('form');
  const formData = Object.fromEntries(new FormData(form).entries());

  // Use the ID passed from the form's onsubmit handler
  formData.id = id;

  try {
    await addToCart(formData);
  } catch (error) {
    updateLoadingBar(0); // Reset loading bar on error
  }

  return false;
}

function updateCartQuantity(quantity) {
  document.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      quantity: quantity
    }
  }));  
}


function adjust_spec() {
  $(".spec--item--title").each(function(index) {
    let data = $(this).attr('data-index');
    let height = $(this).height();
    if (data > 0) {
      $('.adjustment-' + data).css("height", height);
    }

  });

  if (isMobile()){

  $('.spec_wrapper--inner').flickity({
cellAlign: 'left',
contain: true,
arrowShape: {
  x0: 10,
   x1: 60, y1: 50,
   x2: 70, y2: 40,
   x3: 30
}
});

}

}

function spec_top() {

  if ($('.extra--spec').length > 0) {
    var distance = $('.extra--spec').offset().top;
    $window = $(window);

    $window.scroll(function() {
  if(isMobile()){    var distanceToShow = distance + window.screen.height;}else{
        var distanceToShow = distance + 55;
  }


      if ($window.scrollTop() >= distanceToShow) {
        $('.extra--spec').addClass('extra--spec--fixy');
      } else {
        $('.extra--spec').removeClass('extra--spec--fixy');
      }
    });

  }
}

function priceFormator(total) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: Shopify.currency.active,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })

  let formatted = formatter.format(total / 100);
  if ((total / 100) >= 10000) {

    formatted = formatted.replace(",", " ");
  } else {
    formatted = formatted.replace(",", "");
  }

  return formatted;
}

function handleSelect() {
  // $('#quantity_selector').on('change', function() {

  //   let varid = $("#size--modal option:selected").attr('data-variant');
  //   let prid = $("#size--modal option:selected").attr('data-price');
  //   var size = $("#size--modal option:selected").val();

  //   var quantity = $('option:selected', this).val();

  //   var arrow = '<span class="arrow_atc"><svg class="Icon Icon--r_arrow" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z" fill="#FF3743"></path></svg></span>'
  //   var calcualte = prid * quantity;
  //   var formatted = priceFormator(calcualte);
  //   console.log(prid);
  //   if (quantity > 0 && varid > 0) {
  //     $('#price--modal').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");

  //     $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' onclick=addtocartmodal(" + varid + "," + quantity + ")>Add to cart " + arrow + "</button>");
  //   } else {
  //     $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' disabled>Add to cart " + arrow + "</button>");

  //   }
  // });

  $('#size--modal').on('change', function() {

    let varid = $("option:selected", this).attr('data-variant');
    let prid = $("option:selected", this).attr('data-price');
    var size = $("option:selected", this).val();

    var quantity = 1;

    var arrow = '<span class="arrow_atc"><svg class="Icon Icon--r_arrow" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z" fill="#FF3743"></path></svg></span>'
    var calcualte = prid * quantity;
    var formatted = priceFormator(calcualte);
    if (quantity > 0 && varid > 0) {
      $('#price--modal').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");


      /*       if(window.theme['installments']){
                  const price = calcualte / 100 / parseInt(window.theme['installments']);

                                  var formatted = priceFormator(Math.round(price));
                  $('#price--modal ').append(

                    `<div class="Price_Custom--splitIT"><div class="Price_Custom Price_Custom--splitIT u-h5 u-h4_mob text--left mb--S  ">from `+price+` per month <span class="vat">ex. Vat </span> <a target="popup" onclick="popupWindow();">
<svg class="Icon Icon--info_s" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.16667 6.33337H10.8333V8.00004H9.16667V6.33337ZM9.16667 9.66671H10.8333V14.6667H9.16667V9.66671Z" fill="#00A283"></path>
<path d="M10 2.16663C5.4 2.16663 1.66666 5.89996 1.66666 10.5C1.66666 15.1 5.4 18.8333 10 18.8333C14.6 18.8333 18.3333 15.1 18.3333 10.5C18.3333 5.89996 14.6 2.16663 10 2.16663ZM10 17.1666C6.325 17.1666 3.33333 14.175 3.33333 10.5C3.33333 6.82496 6.325 3.83329 10 3.83329C13.675 3.83329 16.6667 6.82496 16.6667 10.5C16.6667 14.175 13.675 17.1666 10 17.1666Z" fill="#00A283"></path>
</svg></a></div></div>`


                  );


                }*/

      $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' data-action='open-drawer' data-drawer-id='sidebar-cart' onclick=addtocartmodal(" + varid + "," + quantity + ")>Add to cart</button>");
    } else {
      $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' disabled>Add to cart</button>");

    }
  });

}

function atcBag(){
  var url = $('#upgradeCheck').attr('data-id');
   if(!url) return;
          ProductService.getBySelector("/products/" + url).then(product => {
            if (product.description) {
              product = product;
            } else {
              product = product.product;
            }



            $('#upgrade-modal2 .modalTitl').html(product.title);
            $('#upgrade-modal2 .modalImg').html("<img id='modalitet' src='" + product.featured_image + "'>");

            var formatted = priceFormator(product.price);
            $('#upgrade-modal2 .modal--price').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");
          
           
            $('.upgradeBag').attr('onclick',`addtocartmodal(${product.variants[0].id})`);
        
          });
          if ($('#upgradeCheck').length == 0) {
            $('.Cart__Checkout').removeAttr(
              "data-action", "aria-controls"

            );
            $('.Modal__Close').click();


          }else{
            $('.Cart__Checkout').attr({
              "data-action": "open-modal",
              "aria-controls": "upgrade-modal2"


            });
          }
     
}

function atc_custom_rec(selectedProductId, product_url) {
  
  if(window.location.href.includes('collections')){
    const url = `products/${product_url}`;
    ProductService.getBySelector(url).then(product => {

      if(product.product){
        product = product.product
        var productImage = product.images[0].src;
      } else {
        product = product;
        var productImage = product.featured_image;
      }
      
      $('.modal--title').html(product.title);
      $('.modal--image').html("<img id='modalitet' src='" + productImage + "'>");
  
      var formatted = priceFormator(0);
  
      $('.modal--product_desc').html(product.description);
      $('#price--modal').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");
      
      // Check if product has only "Default Title" variant
      var hasOnlyDefaultTitle = product.variants.length === 1 && product.variants[0].title === 'Default Title';
      
      if (hasOnlyDefaultTitle) {
        // Hide the variant selector
        $('#selector--size').hide();
        
        // Set price and enable add to cart button immediately
        var defaultVariant = product.variants[0];
        var formatted = priceFormator(defaultVariant.price);
        $('#price--modal').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");
        $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' onclick=addtocartmodal(" + defaultVariant.id + ")>Add to cart</button>");
        
      } else {
        // Show the variant selector for products with real variants
        $('#selector--size').show();
        
        var myParent = document.getElementById("size--modal");
        //Create and append select list
        var selectList = document.createElement("select");
        selectList.id = "add-items";
        selectList.setAttribute('data-action', 'change');
        $('#size--modal').html(selectList);
    
        //Create and append the options
        var option = document.createElement("option");
        option.value = "none";
        option.setAttribute("data-price", "0");
        option.setAttribute("data-variant", "0");
        option.text = "Select range";
        selectList.appendChild(option);
    
        for (var i = 0; i < product.variants.length; i++) {
    
          var option = document.createElement("option");
          option.value = product.variants[i].title;
          option.setAttribute("data-price", product.variants[i].price);
          option.setAttribute("data-variant", product.variants[i].id);
          option.text = product.variants[i].title;
          selectList.appendChild(option);
    
        }
        
        $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' disabled onclick=addtocartmodal(" + product.variants[0].id + ")>Add to cart</button>");
      }
      
      var arrow = '<span class="arrow_atc"><svg class="Icon Icon--r_arrow" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z" fill="#FF3743"></path></svg></span>'

    });
  } else {
    const url = `products/${product_url}`;
    ProductService.getBySelector(url).then(product => {

      if(product.product){
        product = product.product
        var productImage = product.images[0].src;
      } else {
        product = product;
        var productImage = product.featured_image;
      }
      
      $('.modal--title').html(product.title);
      $('.modal--image').html("<img id='modalitet' src='" + productImage + "'>");
  
      var formatted = priceFormator(0);
  
      $('.modal--product_desc').html(product.description);
      $('#price--modal').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");
      
      // Check if product has only "Default Title" variant
      var hasOnlyDefaultTitle = product.variants.length === 1 && product.variants[0].title === 'Default Title';
      
      if (hasOnlyDefaultTitle) {
        // Hide the variant selector
        $('#selector--size').hide();
        
        // Set price and enable add to cart button immediately
        var defaultVariant = product.variants[0];
        var formatted = priceFormator(defaultVariant.price);
        $('#price--modal').html("<span class='money'>" + formatted + "</span><span class='vat'> ex. VAT</span>");
        $('#modal--atc').html("<button class='modal--atc product-item__details u-p4_mob u-p5 fett mt--M' onclick=addtocartmodal(" + defaultVariant.id + ")>Add to cart</button>");
        
      } else {
        // Show the variant selector for products with real variants
        $('#selector--size').show();
        
        var myParent = document.getElementById("size--modal");
        //Create and append select list
        var selectList = document.createElement("select");
        selectList.id = "add-items";
        selectList.setAttribute('data-action', 'change');
        $('#size--modal').html(selectList);
    
        //Create and append the options
        var option = document.createElement("option");
        option.value = "none";
        option.setAttribute("data-price", "0");
        option.setAttribute("data-variant", "0");
        option.text = "Select range";
        selectList.appendChild(option);
    
        for (var i = 0; i < product.variants.length; i++) {
    
          var option = document.createElement("option");
          option.value = product.variants[i].title;
          option.setAttribute("data-price", product.variants[i].price);
          option.setAttribute("data-variant", product.variants[i].id);
          option.text = product.variants[i].title;
          selectList.appendChild(option);
    
        }
        
        $('#modal--atc').html("<button class='modal--atc product-item__details  u-p4_mob u-p5 fett mt--M' disabled onclick=addtocartmodal(" + product.variants[0].id + ")>Add to cart</button>");
      }
      
      var arrow = '<span class="arrow_atc"><svg class="Icon Icon--r_arrow" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z" fill="#FF3743"></path></svg></span>'

    });
  }

  // Only call handleSelect() if variant selector is visible
  if (!$('#selector--size').is(':hidden')) {
    handleSelect();
  }
}


function buildUpgradeSnippet(product_url, currentVariant, quantity, last) {

  var existModal = 0;
  var icon = '<svg class="upgrade--arrow" width="23" height="11" viewBox="0 0 23 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8466 4.1665H0.833313V6.83317H16.8466V10.8332L22.1666 5.49984L16.8466 0.166504V4.1665Z" fill="black"/></svg>';

  ProductService.getBySelector(product_url).then(product => {
    if (product.description) {
      product = product;
    } else {
      product = product.product;
    }

    if (product.product_type == 'Battery') {

      var url1 = window.theme['smallBattery'];

      ProductService.getBySelector("/products/" + url1).then(smallBat => {

        if (smallBat.description) {
          smallBat = smallBat;
        } else {
          smallBat = smallBat.product;
        }

        if (product.id == smallBat.id) {

          var url = window.theme['bigBattery'];
          ProductService.getBySelector("/products/" + url).then(product => {
            if (product.description) {
              product = product;
            } else {
              product = product.product;
            }

            const variantNameO = "15-40 min riding time";
            var formattedO = priceFormator(smallBat.variants[0].price);

            const variantName = "25-50 min riding time";
            var formatted = priceFormator(product.variants[0].price);

            const oldid = product.variants[0].id;
            const id = smallBat.variants[0].id;

            quantity = parseInt(quantity);
            for (i = 0; i < quantity; i++) {
              $('.upgrade-holder').append('<div class="upgrade--flex"><div class="upgrade--item current--upgrade" data-quantityt="' + quantity + '" data-old-id="' + oldid + '" data-id="' + id + '"><div class="upgrade-title u-h6 u-h5_mob">' + smallBat.title + '</div><div class="upgrade-variant u-h6 u-h5_mob">' + variantNameO + '</div><span class="money u-h6 u-h5_mob">' + formattedO + '</span><span class="vat"> ex. VAT</span></div><div class="upgrade--arrow">' + icon + '</div><div class="upgrade--item new--upgrade" data-old-id="' + id + '" data-id="' + oldid + '" data-quantity-old="' + quantity + '"><div class="upgrade-title u-h6 u-h5_mob">' + product.title + '</div><div class="upgrade-variant u-h6 u-h5_mob">' + variantName + '</div><span class="money u-h6 u-h5_mob">' + formatted + '</span><span class="vat"> ex. VAT</span></div></div>');
            }
            $(".upgrade--item").unbind("click");
            upgradeClick();
            $('.loader_overlay').hide();

            if ($('.upgrade--flex').length > 0) {
              $('.Cart__Checkout').attr({
                "data-action": "open-modal",
                "aria-controls": "upgrade-modal"


              });
            }
          });

        } else if (last) {
          if ($('.upgrade--flex').length == 0) {
            $('.Cart__Checkout').removeAttr(
              "data-action", "aria-controls"

            );
            $('.Modal__Close').click();


          }
        }


      });
    } else if (product.variants[0].id == currentVariant && product.product_type == 'Electric surfboard') {


      const variantName = product.variants[1].title;
      var formatted = priceFormator(product.variants[1].price * 100);

      const variantNameO = product.variants[0].title;
      var formattedO = priceFormator(product.variants[0].price * 100);

      const timeO = "15-20 min riding time";
      const time = "20-45 min riding time";
      const oldid = product.variants[1].id;
      const id = product.variants[0].id;

      var i;
      for (i = 0; i < quantity; i++) {
        $('.upgrade-holder').append('<div class="upgrade--flex"><div class="upgrade--item current--upgrade" data-quantity="' + quantity + '" data-old-id="' + oldid + '" data-id="' + id + '"><div class="upgrade-title u-h6 u-h5_mob">' + product.title + '</div><div class="upgrade-variant u-h6 u-h5_mob">' + variantNameO + '</div><div class="upgrade-variant  mb--XS u-h6 u-h5_mob">' + timeO + '</div><span class="money u-h6 u-h5_mob">' + formattedO + '</span><span class="vat"> ex. VAT</span></div>' + icon + '<div class="upgrade--item new--upgrade" data-old-id="' + id + '" data-id="' + oldid + '" data-quantity-old="' + quantity + '"><div class="upgrade-title u-h6 u-h5_mob">' + product.title + '</div><div class="upgrade-variant u-h6 u-h5_mob">' + variantName + '</div><div class="upgrade-variant mb--XS u-h6 u-h5_mob">' + time + '</div><span class="money u-h6 u-h5_mob">' + formatted + '</span><span class="vat"> ex. VAT</span></div></div>');

      }
      $(".upgrade--item").unbind("click");
      upgradeClick();
      $('.loader_overlay').hide();

      if ($('.upgrade--flex').length > 0) {
        $('.Cart__Checkout').attr({
          "data-action": "open-modal",
          "aria-controls": "upgrade-modal"


        });
      }

    } else if (last) {


      setTimeout(function() {
        if ($('.upgrade--flex').length == 0) {

          $('.Cart__Checkout').removeAttr(
            "data-action", "aria-controls"

          );
          $('.Modal__Close').click();


        }



      }, 1000);

    }



  });




}

function upgradeModule() {
  $('.upgrade-holder').html("");

  const url = "";
  const currentVariant = "";
  const quantity = "";
  CartService.get(Date.now()).then(cart => {
    const cartElement = $($.parseHTML(cart));

    var elements = cartElement.find('.Cart__ItemList');

    if (elements.find('.CartItem').length > 0) {
      elements.find('.CartItem').each(function(index) {

        const url = $(this).attr('data-url');
        const currentVariant = $(this).attr('data-id');
        const quantity = $(this).attr('data-quantity');
        var isLastElement = index == elements.find('.CartItem').length - 1;

          atcBag();
        //buildUpgradeSnippet(url, currentVariant, quantity, isLastElement);


      });
    } else {
      if ($('.upgrade--flex').length == 0) {

        $('.Cart__Checkout').removeAttr(
          "data-action", "aria-controls"

        );
        $('.Modal__Close').click();


      }
    }




  });




}

function upgradeClick() {
  $('.upgrade--item').on('click', function() {
    $('.loader_overlay').show();
    $(this).addClass('current--upgrade').siblings().removeClass('current--upgrade');

    const loadingBar = $('.LoadingBar')

    loadingBar.addClass('is-visible');
    loadingBar.css('width', '40%');
    var quant = parseInt($(this).attr('data-quantity-old'));
    const dataold = $(this).attr('data-old-id');
    const dataid = $(this).attr('data-id');
    quant = quant - 1;

    CartService.remove(dataold, quant).then(cart => {

      CartService.add(dataid).then(cart => {

        if (cart) {
          loadingBar.css('width', '80%');

          CartService.get(Date.now()).then(cart => {

            const cartElement = $($.parseHTML(cart));
            const drawerElement = cartElement.find('form');

            const drawerHtml = drawerElement.html();

            const cartFormElement = $('#sidebar-cart').find('form');
            cartFormElement.html(drawerHtml);

            loadingBar.css('width', '100%');
            loadingBar.addClass('is-finished');

            upgradeModule();

          });

        }

        upgradeClick();
      });
    });








  });





}




function upgradeAll() {

  var dataold = {};
  var dataid = {};
  $('.upgrade--all').on('click', function() {
    $('.loader_overlay').show();


    const loadingBar = $('.LoadingBar')

    loadingBar.addClass('is-visible');
    loadingBar.css('width', '40%');
    $(".new--upgrade").each(function(index) {



      dataold[($(this).attr('data-old-id'))] = 0;

      if (dataid[($(this).attr('data-id'))]) {
        dataid[($(this).attr('data-id'))] = dataid[($(this).attr('data-id'))] + 1;
      } else {
        dataid[($(this).attr('data-id'))] = 1;
      }




    });




    CartService.update(dataold).then(cart => {

      CartService.update(dataid).then(cart => {

        if (cart) {
          loadingBar.css('width', '80%');

          CartService.get(Date.now()).then(cart => {

            const cartElement = $($.parseHTML(cart));
            const drawerElement = cartElement.find('form');

            const drawerHtml = drawerElement.html();

            const cartFormElement = $('#sidebar-cart').find('form');
            cartFormElement.html(drawerHtml);

            loadingBar.css('width', '100%');
            loadingBar.addClass('is-finished');



          });

        }
        $('.Cart__Checkout').removeAttr(
          "data-action", "aria-controls"

        );
        $('.Cart__Checkout').click();




      });
    });









  });


}


function modalCheckout() {
  $('.Modal__Checkout').on('click', function() {
    $('.Cart__Checkout').removeAttr(
      "data-action", "aria-controls"

    );
    $('.Modal__Close').click();
    $('.Cart__Checkout').click();

  });

}
function getRetailersGeocode(){

  if(isMobile()){

      $('.additional_retailers-3').each(function() {
$('.retailers_pp_content .retailers').append($(this).html());
$(this).remove();

});

  $('.additional_retailers-2').each(function() {

$('#retailers_popover .countries').append($(this).html());
$(this).remove();

});


  }else{
  $('.additional_retailers').each(function() {
$('.retailers').append($(this).html());
$(this).remove();

});
  }



  var obj = {},
  i = 0;
  $('.geocode_information').each(function() {
      obj[i] = {}
      obj[i]['lat'] = $(this).attr('data-lat');
      obj[i]['lon'] = $(this).attr('data-lon');
      obj[i]['id'] = $(this).attr('data-id');
      i++;
  });
  calcCrow(obj);
return obj;
}

function calcCrow(obj)
{
  const arr = [];
  var lat1= 0, lon1= 0, lat2= 0, lon2= 0, dLat= 0, dLon = 0, d = 0, c = 0, a= 0;


    const keys = Object.keys(obj);
    keys.forEach(k => {
      var lat1 = Math.abs(sessionStorage.getItem('lat'));
      var lon1 = Math.abs(sessionStorage.getItem('lon'));
    var lat2 = obj[k]['lat'];
    var lon2 = obj[k]['lon'];


  var R = 6371; // km
  var dLat = toRad(lat2-lat1);
  var dLon = toRad(lon2-lon1);
   lat1 = toRad(lat1);
   lat2 = toRad(lat2);

  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  var d = R * c;
arr[obj[k]['id']] = d;

  });
var lowest = lowestValueAndKey(arr);
  if(isMobile()){
  $('#ph_'+lowest+"_mob").show();
  }else{
  $('#ph_'+lowest).show();
  }

}

function lowestValueAndKey(obj) {
  var [lowestItems] = Object.entries(obj).sort(([ ,v1], [ ,v2]) => v1 - v2);
  return lowestItems[0];
}



// Converts numeric degrees to radians
function toRad(Value)
{
    return Value * Math.PI / 180;
}


// Revolution Dropdown
/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
    /**
     * Maintain a map of listener
     * lists, keyed by event name.
     *
     * @type Object
     */
    this.listenerMap = [{}, {}];
    if (root) {
        this.root(root);
    }

    /** @type function() */
    this.handle = Delegate.prototype.handle.bind(this);

    // Cache of event listeners removed during an event cycle
    this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;

    // Remove master event listeners
    if (this.rootElement) {
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, true);
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, false);
            }
        }
    }

    // If no root or root is not
    // a dom node, then remove internal
    // root reference and exit here
    if (!root || !root.addEventListener) {
        if (this.rootElement) {
            delete this.rootElement;
        }
        return this;
    }

    /**
     * The root node at which
     * listeners are attached.
     *
     * @type Node
     */
    this.rootElement = root;

    // Set up master event listeners
    for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, true);
        }
    }
    for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, false);
        }
    }

    return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
    return (
        ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
            eventType
        ) !== -1
    );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;

    if (!eventType) {
        throw new TypeError("Invalid event type: " + eventType);
    }

    // handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }

    // Fallback to sensible defaults
    // if useCapture not set
    if (useCapture === undefined) {
        useCapture = this.captureForType(eventType);
    }

    if (typeof handler !== "function") {
        throw new TypeError("Handler must be a type of Function");
    }

    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];

    // Add master handler for type if not created yet
    if (!listenerMap[eventType]) {
        if (root) {
            root.addEventListener(eventType, this.handle, useCapture);
        }
        listenerMap[eventType] = [];
    }

    if (!selector) {
        matcherParam = null;

        // COMPLEX - matchesRoot needs to have access to
        // this.rootElement, so bind the function to this.
        matcher = matchesRoot.bind(this);

        // Compile a matcher for the given selector
    } else if (/^[a-z]+$/i.test(selector)) {
        matcherParam = selector;
        matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
        matcherParam = selector.slice(1);
        matcher = matchesId;
    } else {
        matcherParam = selector;
        matcher = Element.prototype.matches;
    }

    // Add to the list of listeners
    listenerMap[eventType].push({
        selector: selector,
        handler: handler,
        matcher: matcher,
        matcherParam: matcherParam,
    });

    return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;

    // Handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }

    // If useCapture not set, remove
    // all event listeners
    if (useCapture === undefined) {
        this.off(eventType, selector, handler, true);
        this.off(eventType, selector, handler, false);
        return this;
    }

    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
        for (singleEventType in listenerMap) {
            if (listenerMap.hasOwnProperty(singleEventType)) {
                this.off(singleEventType, selector, handler);
            }
        }

        return this;
    }

    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
        return this;
    }

    // Remove only parameter matches
    // if specified
    for (i = listenerList.length - 1; i >= 0; i--) {
        listener = listenerList[i];

        if (
            (!selector || selector === listener.selector) &&
            (!handler || handler === listener.handler)
        ) {
            this._removedListeners.push(listener);
            listenerList.splice(i, 1);
        }
    }

    // All listeners removed
    if (!listenerList.length) {
        delete listenerMap[eventType];

        // Remove the main handler
        if (this.rootElement) {
            this.rootElement.removeEventListener(eventType, this.handle, useCapture);
        }
    }

    return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";

    if (event[eventIgnore] === true) {
        return;
    }

    target = event.target;

    // Hardcode value of Node.TEXT_NODE
    // as not defined in IE8
    if (target.nodeType === 3) {
        target = target.parentNode;
    }

    // Handle SVG <use> elements in IE
    if (target.correspondingUseElement) {
        target = target.correspondingUseElement;
    }

    root = this.rootElement;

    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

    // eslint-disable-next-line default-case
    switch (phase) {
        case 1: //Event.CAPTURING_PHASE:
            listenerList = this.listenerMap[1][type];
            break;
        case 2: //Event.AT_TARGET:
            if (this.listenerMap[0] && this.listenerMap[0][type]) {
                listenerList = listenerList.concat(this.listenerMap[0][type]);
            }
            if (this.listenerMap[1] && this.listenerMap[1][type]) {
                listenerList = listenerList.concat(this.listenerMap[1][type]);
            }
            break;
        case 3: //Event.BUBBLING_PHASE:
            listenerList = this.listenerMap[0][type];
            break;
    }

    let toFire = [];

    // Need to continuously check
    // that the specific list is
    // still populated in case one
    // of the callbacks actually
    // causes the list to be destroyed.
    l = listenerList.length;
    while (target && l) {
        for (i = 0; i < l; i++) {
            listener = listenerList[i];

            // Bail from this loop if
            // the length changed and
            // no more listeners are
            // defined between i and l.
            if (!listener) {
                break;
            }

            if (
                target.tagName &&
                ["button", "input", "select", "textarea"].indexOf(
                    target.tagName.toLowerCase()
                ) > -1 &&
                target.hasAttribute("disabled")
            ) {
                // Remove things that have previously fired
                toFire = [];
            }
            // Check for match and fire
            // the event if there's one
            //
            // TODO:MCG:20120117: Need a way
            // to check if event#stopImmediatePropagation
            // was called. If so, break both loops.
            else if (listener.matcher.call(target, listener.matcherParam, target)) {
                toFire.push([event, target, listener]);
            }
        }

        // TODO:MCG:20120117: Need a way to
        // check if event#stopPropagation
        // was called. If so, break looping
        // through the DOM. Stop if the
        // delegation root has been reached
        if (target === root) {
            break;
        }

        l = listenerList.length;

        // Fall back to parentNode since SVG children have no parentElement in IE
        target = target.parentElement || target.parentNode;

        // Do not traverse up to document root when using parentNode, though
        if (target instanceof HTMLDocument) {
            break;
        }
    }

    let ret;

    for (i = 0; i < toFire.length; i++) {
        // Has it been removed during while the event function was fired
        if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
            continue;
        }
        returned = this.fire.apply(this, toFire[i]);

        // Stop propagation to subsequent
        // callbacks if the callback returned
        // false
        if (returned === false) {
            toFire[i][0][eventIgnore] = true;
            toFire[i][0].preventDefault();
            ret = false;
            break;
        }
    }

    return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
    if (this.rootElement === window) {
        return (
            // Match the outer document (dispatched from document)
            element === document ||
            // The <html> element (dispatched from document.body or document.documentElement)
            element === document.documentElement ||
            // Or the window itself (dispatched from window)
            element === window
        );
    }
    return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
    return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
    this.off();
    this.root();
};

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    if (first) {
        first.focus();
    } else {
        elementToFocus.focus();
    }



}



function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}


class DomHelper {
    constructor() { }
    getSiblings(element, filter) {
        var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var siblings = [];
        var currentElement = element;

        // Do the previous first
        while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        if (includeSelf) {
            siblings.push(element);
        }

        // Then the next side
        currentElement = element;

        while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        return siblings;
    }

    nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
                items.push(nodeList[i]);
            }
        }

        return items;
    }
    outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);

        return width;
    }
    outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);as

        return height;
    }
}
  

class RevolutionSelectbox {
    constructor(element, popover, additionalOverlay) {
        this.element = element;
        this.popover = popover;
        this.changeOverlay = additionalOverlay;
        this.domDelegate = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.dropdown = this.element.querySelector('.RevolutionDropdown');
        this.mainDropdown = this.element.querySelector(".RevolutionDropdown--Content");
        this.mainDropdownContent = this.element.querySelector(".RevolutionDropdown--InnerContent");
        this.mainButton = this.element.querySelector(".RevolutionDropdown--Button");
        this.connectedSelect = this.element.getAttribute('data-select');

        this.selectbox = this.element.querySelector(`#${this.connectedSelect}`);

        if (!this.selectbox == null){
          this.selectbox = this.element.querySelector('[name=' + this.connectedSelect + ']');
        }
        if (this.selectbox == null) {
            this.selectbox = this.element.querySelector('[name2=' + this.connectedSelect + ']');
        }
        if(this.popover == true){
          this.mainDropdown.classList.add('PopoverContent');
          if(this.changeOverlay){
              this.pageOverlayElement = document.querySelector(".localizationOverlay");
          }else{
              this.pageOverlayElement = document.querySelector(".pageOverlay");
          }

        }
        this.bindEvents();
        this.initSelectbox();
    }

    bindEvents() {
        this.onClickOutsideListener = this.onClickOutside.bind(this);
        this.domDelegate.on(
            "click",
            "[data-action=toggle-selectbox]",
            this.toggleDropdown.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
        );

        this.domDelegate.on(
           "click",
           "[data-action=selectbox-change]",
           this.selectboxChange.bind(this)
       );

       this.domDelegate.on(
        "click",
        "[data-action=selectbox-change2]",
        this.selectboxChange2.bind(this)
    );


        this.domDelegate.on(
            "click",
            "[data-action=special-close]",
            this.toggleDropdown.bind(this)
        );
        this.domDelegate.on('click', 'body', this.onClickOutside.bind(this));

    }

    selectboxChange() {
       var value = event.target.getAttribute('data-value');
       var selectboxID = event.target.getAttribute('data-selectboxid');
       var innerContent = event.target.innerHTML;
       var selEl = this.element.querySelector('#' + selectboxID);
       if (selEl.nodeName == "SELECT") {
           selEl.value = value;
           selEl.dispatchEvent(new Event('change'));
       } else {
           selEl.querySelector('[value="' + value + '"]').setAttribute('checked', 'true');
       }
       this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = innerContent;
       this.closeDropdown(this.element);
   }

   selectboxChange2() {
    var value = event.target.getAttribute('data-value');
    var selectboxID = event.target.getAttribute('data-selectboxid');
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector('#' + selectboxID);
    if (selEl.nodeName == "SELECT") {
        selEl.value = value;
        selEl.dispatchEvent(new Event('change'));
    } else {
        selEl.value = value;
    }
    this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = innerContent;
    this.closeDropdown(this.element);
}

    onClickOutside(event) {
        const withinBoundaries = event.composedPath().includes(this.element);
        if (!withinBoundaries || event.target.classList.contains('FiltersDesktopWrapper')) {
            this.closeDropdown(this.element);
        }
    }

    selectboxSubmit() {
      var value = event.target.getAttribute('data-value');
      var dataName = event.target.getAttribute('data-name');
     // this.selectbox.value = value;
      this.closeDropdown(this.element);
      this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = dataName;
  //  this.selectbox.parentElement.submit();
  }

    initSelectbox() {
        var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
            titleElement = this.element.querySelector('.RevolutionDropdown--Title');
        if (selectedItem) {
            titleElement.innerHTML = selectedItem.getAttribute('data-name');
        }
        trapFocus(this.element);

        this.element.style.display = "block";

    }

    toggleDropdown(event, target) {
        var isOpen = target.getAttribute("aria-expanded") === "true";
        if (isOpen) {
            this.closeDropdown(target);
        } else {
            this.openDropdown(target);
        }
    }

    openDropdown(target) {
      this.element.dispatchEvent(new CustomEvent('closeSearch', { bubbles: true }));
        var siblings = new DomHelper().getSiblings(target.parentElement, '.RevolutionDropdown');
        siblings.forEach(function (item) {
            item.querySelector('.RevolutionDropdown--Button').setAttribute("aria-expanded", false);
            item.querySelector('.RevolutionDropdown--Content').setAttribute("aria-hidden", true);
            item.querySelector('.RevolutionDropdown--Content').style.display = "none";

        });

        if(this.popover == true){
          this.pageOverlayElement.classList.add("is-visible");
          this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
          var focus = this.element.querySelector('[data-scrollable]');
          bodyScrollLock.disableBodyScroll(focus);
          document.body.classList.add('scrollLock');
          trapFocus(this.mainDropdown);
        }

        target.setAttribute("aria-expanded", true);
        target.parentElement.querySelector('.RevolutionDropdown--Content').setAttribute("aria-hidden", false);
        target.parentElement.querySelector('.RevolutionDropdown--Content').style.display = "block";
        window.addEventListener("click", this.onClickOutsideListener);
    }

    closeDropdown(target) {

        var closestDropdown = target.closest(".RevolutionDropdown");

        if (closestDropdown === null) {
            var closestDropdown = target.querySelector("[aria-expanded='true']").parentElement;
        }

        closestDropdown.querySelector('.RevolutionDropdown--Button').setAttribute("aria-expanded", false);
        closestDropdown.querySelector('.RevolutionDropdown--Content').setAttribute("aria-hidden", true);
        setTimeout(() => { closestDropdown.querySelector('.RevolutionDropdown--Content').style.display = "none"; }, 300);
        if(this.popover == true){
          this.pageOverlayElement.classList.remove("is-visible");
          this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
          removeTrapFocus(this.mainDropdownContent);
        }

        window.removeEventListener("click", this.onClickOutsideListener);
    }

}

class NewsletterPopup extends HTMLElement{
  constructor(){
    super();
    this.element = this;
    const observer = new MutationObserver(this.openedPopup);
    observer.observe(this.element, {attributes: true});
  }

  openedPopup(mutationList, observer) {

    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName == 'aria-hidden') {
        const popup_status = mutation.target.getAttribute('aria-hidden'); // true or false
        if (popup_status === 'false') {
          document.querySelector(".PageOverlay--black").classList.add("is-visible");
          return;
        } 
          document.querySelector(".PageOverlay--black").classList.remove("is-visible");
      }
    }
  }
}

customElements.define("newsletter-popup", NewsletterPopup);


class CountrySelector extends HTMLElement{
  constructor(){
    super();
    this.element = this;
    new RevolutionSelectbox(this.element);
  }


}
customElements.define("country-selector", CountrySelector);


class KlaviyoHandler extends HTMLElement{
  constructor(){
    super();

    return;
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
      this.delegateElement.on(
          "click",
          '[data-action="sendToKlaviyo"]',
          this.klaviyoSubmit.bind(this)
      );

  }


  klaviyoSubmit(){
    event.preventDefault();
    const formElement = event.target.closest("form"),
          listID = formElement.querySelector('[name="g"]').value,
          first_name = formElement.querySelector('[name="first_name"]').value,
          last_name = formElement.querySelector('[name="last_name"]').value,
          email = formElement.querySelector('[name="email"]').value,
          country = formElement.querySelector('[name="country"]').value,
          source = formElement.querySelector('[name="source"]').value,
          errorMsg = this.element.querySelector('.error_message');
          

    if (first_name == '' || last_name == '' || email == '' ) {
      errorMsg.style.display = 'block';

      return false;
    } else {
      errorMsg.style.display = 'none';
    var settings = {
    "async": true,
    "crossDomain": true,
    "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    "method": "POST",
    "headers": {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache"
    },
    "data": {
      "g": listID,
      "$fields": "$first_name,$last_name,$country,$source",
      "email": email,
      "$country": country,
      "$first_name": first_name,
      "$last_name": last_name,
      "$source": source
    }
    }


    $.ajax(settings).done(function (response) {


     if(response.success){
        formElement.innerHTML = window.languages.newsletter_success;
     }
    });
  }

  }

}
customElements.define("klaviyo-handler", KlaviyoHandler);


$(window).on("load",function(){
    let _thiss = $("main#main > div:first-child").find(".wrapper_click--video");
  
        const id = _thiss.attr('data-id');
      let customID = "my-player-" + id;

      let myPlayer = videojs.getPlayer(customID);
myPlayer.play();

});


class Drawer {
  constructor(element) {
      var options =
          arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.pageOverlayElement = document.querySelector(".pageOverlay");

      if (navigator.platform === "iPhone")
          document.documentElement.style.setProperty(
              "--viewport-height",
              `${window.innerHeight}px`
          );
      this.onOpen = options["onOpen"] || function () { };
      this.onClose = options["onClose"] || function () { };
      this.isOpen = false;

      if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
          new RevolutionAnimation(this.element);
        }


      this.bindEvents();
  }

  bindEvents() {
      this.delegateBody.on(
          "click",
          '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
          this.openDrawer.bind(this)
      );
      this.delegateBody.on(
          "click",
          '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
          this.closeDrawer.bind(this)
      );
      this.delegateBody.on(
          "click",
          '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
          this.toggleDrawer.bind(this)
      );
      this._openListener = this.openDrawer.bind(this);
      this._closeListener = this.closeDrawer.bind(this);
      this.calculateMaxHeightListener = this.maxHeight.bind(this);
      window.addEventListener("resize", this.calculateMaxHeightListener);
  }

  maxHeight() {
      this.element.style.height = window.innerHeight + "px";
      if (
          this.element.getAttribute("id") == "cart" ||
          this.element.getAttribute("id") == "sidebarFavorites"
      ) {
          var footer = this.element.querySelector(
              ".CartDrawer--Footer"
          );
          var footerHeight = 0;
          if (footer !== null) {
              footerHeight = footer.offsetHeight;
          }

          var header = this.element.querySelector(".CartHeader").offsetHeight;
          var cartItem = this.element.querySelector(".cart-item");
          if (cartItem !== null) {
              var itemHeight = cartItem.offsetHeight;
          }

          var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

          if (itemWrapper !== null) {
              itemWrapper.style.height = window.innerHeight - footerHeight - header + "px";
          }



      }
  }

  toggleDrawer() {
      event.preventDefault();
      this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
      this.element.dispatchEvent(new CustomEvent('closeSearch', { bubbles: true }));
      setTimeout(() => {
        if (this.element.getAttribute("id") == "cart") {
          var count = window.theme.cartCount;

          if (count > 0) {
            this.element
              .querySelector(".CartDrawer--Expendable")
              .setAttribute("aria-expanded", true);
          }
        }
      }, 200);

        if (this.isOpen) {
            return;
        }

            var drawers = document.querySelectorAll(
                '#favoritesDrawer[aria-expanded="true"]'
            );
            drawers.forEach((item, i) => {
                item.setAttribute("aria-expanded", "false");
                removeTrapFocus(item);
                this.closeAnimation(item);
                item.isOpen = false;
            });


        this.maxHeight();
        if (this.element.getAttribute("id") == "sidebarDrawer") {
          document.querySelector(".SidebarDrawer__Close").style.display = "block";
          this.element.dispatchEvent(
            new CustomEvent("sidebar-drawer:open", {
              bubbles: true,
            })
          );
        } else if (this.element.getAttribute("id") == "favoritesDrawer") {
          this.element.dispatchEvent(
            new CustomEvent("favorite-product:open", {
              bubbles: true,
            })
          );
        }
        this.element.setAttribute("aria-expanded", "true");
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);
        var focus = this.element.querySelector('[data-scrollable]');
        bodyScrollLock.disableBodyScroll(focus);
        document.body.classList.add('scrollLock');
        this.isOpen = true;
        trapFocus(this.element);
        this.onOpen();
        return false;
    }

  closeDrawer(event) {
      if (!this.isOpen) {
          return;
      }
      if (event) {
          event.preventDefault();
      }

      if (this.element.getAttribute("id") == "sidebarDrawer") {
      }
      document.body.classList.remove('scrollLock');

      bodyScrollLock.clearAllBodyScrollLocks();
      if (this.element.getAttribute("id") == "cart") {
        var options = JSON.parse(this.element.getAttribute("data-settings"));
        if(options['showRecommendations']){
          this.element
              .querySelector(".CartDrawer--Expendable")
              .setAttribute("aria-expanded", false);
              setTimeout(() => {    this.element.querySelector('.CustomCart__Recommendations').innerHTML = ""}, 800);

        }

      }
      this.element.setAttribute("aria-expanded", "false");

      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
      removeTrapFocus(this.element);
      this.closeAnimation(this.element);
      this.isOpen = false;
      this.onClose();
  }

  onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
  }

  closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
          if (animationStart === undefined) {
              animationStart = time;
          }

          const elapsedTime = time - animationStart;

          if (elapsedTime < 400) {
              window.requestAnimationFrame(handleAnimation);
          } else {
              detailsElement.removeAttribute("open");
              if (detailsElement.closest("details[open]")) {
                  trapFocus(
                      detailsElement.closest("details[open]"),
                      detailsElement.querySelector("summary")
                  );
              }
          }
      };

      window.requestAnimationFrame(handleAnimation);
  }
}



class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.SidebarMenu = new Drawer(this.element);

    this.bindEvents();
  }
  bindEvents() {
  this.delegateElement.on(
    "click",
    '[data-action="toggle-subdrawer"]',
    this.toggleNextElement.bind(this)
  );

  this.delegateElement.on(
  "click",
  '[data-action="toggle-prev-subdrawer"]',
  this.togglePreviusElement.bind(this)
);
  }

  toggleNextElement(target){
      var nextEl = target.getAttribute('data-toggle-id'),
        subdrawer = this.element.querySelector('#'+nextEl);
        if(subdrawer && subdrawer.getAttribute('aria-hidden') == "true" ){
            subdrawer.setAttribute('aria-hidden', "false");

        }

  }
  togglePreviusElement(target){

    target.closest('.SidebarDrawer--Wrapper').setAttribute("aria-hidden", "true");
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);


class AccessoriesHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.form = this.element.querySelector('form');
    this.initCarousel();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-accessories"]',
      this.toggleAccessorie.bind(this)
    );

  
    this.delegateElement.on(
      "click",
      '[data-action="customize-board"]',
      this.customizeAction.bind(this)
    );

    this.delegateElement.on("click", '[data-action="add-to-cart-accessories"]', this.handleATC.bind(this));


  }


  customizeAction(){
    event.preventDefault();
    const error = this.element.querySelectorAll('.errorVariant');
    error.forEach((item) =>{
      item.setAttribute('aria-hidden', 'false');
      item.parentElement.querySelector('.variantInfo').setAttribute('aria-hidden', 'true');
    });
  
    this.element.querySelector('.ProductForm__Variants').scrollIntoView({
      behavior: 'smooth'
    });
  }

  selectedBoard(){
    const error = this.element.querySelectorAll('.errorVariant');
    error.forEach((item) =>{
      item.setAttribute('aria-hidden', 'true');
      item.parentElement.querySelector('.variantInfo').setAttribute('aria-hidden', 'false');
    });
  


  }


  handleATC(){
    this.selectedBoard();
  event.preventDefault();
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  const addToCartButton = $('.ProductForm__AddToCart');
  addToCartButton.attr('disabled');
  const serializedArray = $(this.form).serializeArray()
  const mainData = serializedArray.reduce((acc, val) => {
    acc[val.name] = val.value;
    return acc;
  }, {})

  const data = {
    items: []
  }

  const accessories = this.form.querySelectorAll('[data-inputcart="true"]');

  accessories.forEach((item) => {
    data.items.push({
      quantity: 1,
      id: item.dataset.id
    });
  });


 data.items.push({
    quantity: mainData.quantity,
    id: mainData.id
  });

  fetch(window.theme.localeRootUrl + '/cart/add.js', {
    body: JSON.stringify(data),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function(response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.ok) {
      addToCartButton.removeAttr('disabled');

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: data.id,
          quantity: data.quantity
        }
      }));
    } else {
      response.json().then(function(content) {
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];
        addToCartButton.removeAttribute('disabled');
        addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
        setTimeout(function() {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
  
  }

  initCarousel(){
    this.carousel = this.element.querySelector('[data-flickity-config]');
    this.options = JSON.parse(this.carousel.getAttribute('data-flickity-config'));

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.flickity = new Flickity(this.carousel, this.options);

    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '-200px 0px 0px 0px'}).observe(this.carousel);

    addEventListener('resize', (event) => {
      this.flickity.resize();
    });


  }

  toggleAccessorie(){
    this.button = this.element.querySelector('.BundleAddToCart');
    var allPrices = 0;


    if (event.target.dataset.toggled == "false"){
      event.target.classList.add('accessorie-selected');
      event.target.setAttribute('data-toggled', 'true');
      const addID = event.target.dataset.id;
      const newInput = document.createElement('input');
      newInput.setAttribute('id', `accessorie-${addID}`);
      newInput.setAttribute('type','hidden');
      newInput.setAttribute('data-inputcart','true');
      newInput.setAttribute('data-id', addID);

      this.form.append(newInput);
  
    }else{
      event.target.classList.remove('accessorie-selected');
      event.target.setAttribute('data-toggled', 'false');
      const addID = event.target.dataset.id;

      this.form.querySelector(`#accessorie-${addID}`).remove();
 
    }
    const allSelected = this.element.querySelectorAll('[data-toggled="true"]');
    allSelected.forEach((item) => {
      allPrices += parseInt(item.dataset.price);
    });
    const newPrice = parseInt(this.button.dataset.price) + allPrices;
    var formattednewPrice = priceFormator(newPrice);
    window.theme.accessoriesSum = allPrices;
    this.button.querySelector('[data-money-convertible]').innerHTML = `${formattednewPrice} <span class="vat"> ex. VAT</span>`;

  }

  
}
customElements.define("accessories-handler", AccessoriesHandler);


class SeoSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.documentDelegate = new domDelegate.Delegate(document.body);
    this.content =  this.element.querySelector(".productNew--description");
    this.documentDelegate.on('click', '[data-action="show-more"]', this._onClick.bind(this));
    this.buttonOpen = this.element.querySelector('#text1');
    this.buttonClose =  this.element.querySelector('#text2');
    this.icon = this.element.querySelector('#icon svg');
    this.isOpen = false; 

    this.checkSlide();
  }

  checkSlide(){
    if(this.content.getAttribute('aria-hidden') == 'false'){
      this.buttonOpen.classList.add('hiddeBtnText');
      this.buttonClose.classList.remove('hiddeBtnText');
      this.icon.style.transform = "rotate(180deg)";
    } else {
      this.content.style.height = `36px`;
      this.buttonOpen.classList.remove('hiddeBtnText');
      this.buttonClose.classList.add('hiddeBtnText');
      this.icon.style.transform = "rotate(0deg)";
    }
  }

  _onClick(){ 

    if (this.isOpen == false ){
      this.slideDown();
      this.isOpen = true;
    }else{
      this.slideUp();
      this.isOpen = false;
    }
  
  }
  
  slideUp() {
    this.content.style.height = this.content.scrollHeight + "px";
    this.content.offsetHeight;
    this.content.style.height = `36px`;
    this.content.setAttribute("aria-hidden", true);
    this.buttonOpen.classList.remove('hiddeBtnText');
    this.buttonClose.classList.add('hiddeBtnText');
    this.icon.style.transform = "rotate(0deg)";
  }

  slideDown() {
    if (this.content.style.height === "auto") {
      return;
    }
    var _this = this;
    this.content.style.height = this.content.scrollHeight + "px";
    this.content.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.content.style.height = "auto";
        _this.content.removeEventListener("transitionend", transitionEnded);
      }
    };
    this.buttonOpen.classList.add('hiddeBtnText');
    this.buttonClose.classList.remove('hiddeBtnText');
    this.icon.style.transform = "rotate(180deg)";
    this.content.addEventListener("transitionend", transitionEnded);
  }


}
customElements.define("seo-section", SeoSection);


class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.documentDelegate = new domDelegate.Delegate(document.body);
    this.allBoxes = this.querySelectorAll('.RevolutionDropdown');
    this.allBoxes.forEach((item) =>{
      new RevolutionSelectbox(item);
    });

  }

}
customElements.define("contact-section", ContactSection);

class animationSection extends HTMLElement {
  constructor() {
    super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);

      if(window.theme.enableAnimations){
        this.revealAnimations();
      } else {
       var revelContainer = this.element.querySelectorAll('.hideReveal');
        revelContainer.forEach(container => {
          container.style.display = 'none'
        });
        var animatedTexts = this.element.querySelectorAll('.animatedText');
        animatedTexts.forEach(text => {
          text.style.opacity = '1';
          text.style.transform = 'unset';
          text.style.transition = 'unset'
        });
      }
     
      const containers = this.element.querySelectorAll('.counter');
      containers.forEach(container => {
      let text = container.textContent;
      container.innerHTML = '';
   
      var i;
      for (i = 0; i < text.length; i++) {
        const span = document.createElement('span');
        span.innerHTML = text.charAt(i);
        container.appendChild(span);
        span.classList.add('counterText');
        span.style.cssText = '--i:' + i;
      }
    })
    
  }

  revealAnimations(){
    /*Text animation*/
    let revelText = this.element.querySelectorAll('.animatedText');
   
    let appearTextOptions = {
      threshold: 0
    }

    const appearTextOnScroll = new IntersectionObserver(function(entries, appearTextOnScroll){
      entries.forEach(entry => {
        if (!entry.isIntersecting){
          return;
        }else{
          entry.target.classList.add('TextAppear');
          appearTextOnScroll.unobserve(entry.target);
        }
      })
    }, appearTextOptions);

    revelText.forEach(text => {
      appearTextOnScroll.observe(text);
    });

    /*Image animation*/
    let revelImages = this.element.querySelectorAll('.animationWrapper');
   
    let appearImageOptions = {
      threshold: 0.5,
      rootMargin: "50px"
    }

    const appearImageOnScroll = new IntersectionObserver(function(entries, appearImageOnScroll){
      entries.forEach(entry => {
        if (!entry.isIntersecting){
          return;
        }else{
          entry.target.classList.add('imageAppear');
          appearImageOnScroll.unobserve(entry.target);
        }
      })
    }, appearImageOptions);


    revelImages.forEach(image => {
      appearImageOnScroll.observe(image);
    });

    /*Banner animation*/
    let bannerImage = this.element.querySelectorAll('.bannerImageAnimation');
   
    let appearOptions_2 = {
      threshold: 1,
      rootMargin: "50px"
    }

    const appearBannerOnScroll = new IntersectionObserver(function(entries, appearBannerOnScroll){
      entries.forEach(entry => {
        if (!entry.isIntersecting){
          return;
        }else{
          entry.target.classList.add('imageAppear');
          appearBannerOnScroll.unobserve(entry.target);
        }
      })
    }, appearOptions_2);

 
    bannerImage.forEach(image => {
      appearBannerOnScroll.observe(image);
    });

    /*Counter text*/
    let counters = this.element.querySelectorAll('.CounterSection');
    
    let appearCounterOptions = {
      threshold: 1
    }  
    
    const countOnScroll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.classList.add("show", entry.isIntersecting)
      })
    }, appearCounterOptions)

    counters.forEach(counter => {
      countOnScroll.observe(counter);
    })

  }

}
customElements.define("animation-section", animationSection);

class RequestForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.documentDelegate = new domDelegate.Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.allBoxes = this.querySelectorAll('.RevolutionDropdown');
    this.allBoxes.forEach((item) =>{
      new RevolutionSelectbox(item);
    });

    this.requestForm = this.element.querySelector('#request-modal');
    this.contactModal = this.element.querySelector('#contact-modal');

    this.overlay = document.querySelector('.PageOverlay');
    this.overlay.style.backgroundColor = 'transparent';

    this.bindEvents();
    this.checkform();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="show-request-form"]',
      this.showRequestForm.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
  }

  showRequestForm(){
    this.requestForm.setAttribute('aria-hidden', 'false');
    this.contactModal.setAttribute('aria-hidden', 'true');
  }

  closeModal(){
    this.requestForm.setAttribute('aria-hidden', 'true');
  }

  checkform(){
    const submitBtn = this.element.querySelector('.Form__Submit');
    let form = this.element.querySelector('.Form');
    const uName = this.element.querySelector('#u-name')
 
    const checkEnableButton = () => {
      submitBtn.disabled = !(
          uName.value
       )
    }
    
    uName.addEventListener('change', checkEnableButton);
    submitBtn.addEventListener('click', function() {
      form.submit()
    })
}

}
customElements.define("request-form", RequestForm);

class ProductMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="add-to-cart"]', this.handleATC.bind(this));
  }

  async handleATC(){
    event.preventDefault();
    const form = event.target.closest(".ProductForm__AddToCart");
    if (!form) return;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const addToCartButton = $('.ProductForm__AddToCart button');
    addToCartButton.attr('disabled');

    const serializedArray = $(form).serializeArray()
    const mainData = serializedArray.reduce((acc, val) => {
      acc[val.name] = val.value;
      return acc;
    }, {})

    try {
      const response = await fetch(window.theme.localeRootUrl + '/cart/add.js', {
        body: JSON.stringify(mainData),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        addToCartButton.removeAttr('disabled');
  
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
            detail: {
            variant: mainData.id,
            quantity: mainData.quantity
          }
        }));
      } else {
        const content = await response.json();

        const errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];

        addToCartButton.removeAttribute('disabled');
        addToCartButton.insertAdjacentElement('afterend', errorMessageElement);

        setTimeout(function() {
          errorMessageElement.remove();
        }, 2500);

        throw errorMessageElement;
      }
    } catch(error) {
      console.error("Add to cart failed", error)
    }
  }
}
customElements.define("product-mega-menu", ProductMegaMenu);